/**
 * Main container component for the rules system
 */

import './RulesSection.css';
import { useState } from 'react';
import RulesSummary from './RulesSummary';
import AddRuleForm from './AddRuleForm';
import RulesList from './RulesList';

function RulesSection({
    rules,
    validationStatus,
    onAddRule,
    onDeleteRule,
    onCombineRules,
    onSuggest
}) {
    const [showAddForm, setShowAddForm] = useState(false);
    const [selectedRuleIds, setSelectedRuleIds] = useState([]);

    const handleAddRule = (newRule) => {
        onAddRule(newRule);
        setShowAddForm(false);
    };

    const handleCancelAdd = () => {
        setShowAddForm(false);
    };

    const handleRuleSelect = (ruleId) => {
        setSelectedRuleIds(prev =>
            prev.includes(ruleId)
                ? prev.filter(id => id !== ruleId)
                : [...prev, ruleId]
        );
    };

    const handleCombine = () => {
        if (selectedRuleIds.length < 2) {
            alert('Vyberte alespoň 2 pravidla pro kombinaci');
            return;
        }
        onCombineRules(selectedRuleIds);
        setSelectedRuleIds([]);
    };

    return (
        <div className="rules-section">
            <div className="rules-header">
                <h2 className="section-title">Pravidla četby</h2>
                <div className="rules-header-actions">
                    <button
                        className="btn-combine"
                        onClick={handleCombine}
                        disabled={selectedRuleIds.length < 2}
                    >
                        Kombinovat ({selectedRuleIds.length})
                    </button>
                    <button
                        className="btn-toggle-form"
                        onClick={() => setShowAddForm(!showAddForm)}
                    >
                        {showAddForm ? '− Skrýt formulář' : '+ Přidat pravidlo'}
                    </button>
                </div>
            </div>

            <RulesSummary
                validationStatus={validationStatus}
                rulesCount={rules.length}
            />

            {showAddForm && (
                <AddRuleForm
                    onAdd={handleAddRule}
                    onCancel={handleCancelAdd}
                />
            )}

            <RulesList
                rules={rules}
                validationStatus={validationStatus}
                onDelete={onDeleteRule}
                selectedRuleIds={selectedRuleIds}
                onRuleSelect={handleRuleSelect}
                onSuggest={onSuggest}
            />
        </div>
    );
}

export default RulesSection;
